module.exports = __webpack_public_path__ + "img/logo.2e1d3339.png";